/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1PersonIdAddressesAddresspersonidMutationResponse,
  DeleteApiV1PersonIdAddressesAddresspersonidPathParams,
  DeleteApiV1PersonIdAddressesAddresspersonid401,
  DeleteApiV1PersonIdAddressesAddresspersonid404,
  DeleteApiV1PersonIdAddressesAddresspersonid500,
} from "../../types/personRegisterController/DeleteApiV1PersonIdAddressesAddresspersonid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1PersonIdAddressesAddresspersonid } from "../../clients/personRegisterController/deleteApiV1PersonIdAddressesAddresspersonid.ts";

export const deleteApiV1PersonIdAddressesAddresspersonidMutationKey = () =>
  [{ url: "/api/v1/person/:id/addresses/:addressPersonId" }] as const;

export type DeleteApiV1PersonIdAddressesAddresspersonidMutationKey = ReturnType<
  typeof deleteApiV1PersonIdAddressesAddresspersonidMutationKey
>;

export function deleteApiV1PersonIdAddressesAddresspersonidMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteApiV1PersonIdAddressesAddresspersonidMutationKey();
  return mutationOptions<
    DeleteApiV1PersonIdAddressesAddresspersonidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1PersonIdAddressesAddresspersonid401
      | DeleteApiV1PersonIdAddressesAddresspersonid404
      | DeleteApiV1PersonIdAddressesAddresspersonid500
    >,
    {
      id: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["id"];
      addressPersonId: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, addressPersonId }) => {
      return deleteApiV1PersonIdAddressesAddresspersonid(
        id,
        addressPersonId,
        config,
      );
    },
  });
}

/**
 * @description Remove um endereço vinculado à pessoa. **(Requer Authorization para autenticação)**
 * @summary Excluir endereço da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/addresses/:addressPersonId}
 */
export function useDeleteApiV1PersonIdAddressesAddresspersonid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1PersonIdAddressesAddresspersonidMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1PersonIdAddressesAddresspersonid401
        | DeleteApiV1PersonIdAddressesAddresspersonid404
        | DeleteApiV1PersonIdAddressesAddresspersonid500
      >,
      {
        id: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["id"];
        addressPersonId: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiV1PersonIdAddressesAddresspersonidMutationKey();

  const baseOptions =
    deleteApiV1PersonIdAddressesAddresspersonidMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiV1PersonIdAddressesAddresspersonidMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1PersonIdAddressesAddresspersonid401
        | DeleteApiV1PersonIdAddressesAddresspersonid404
        | DeleteApiV1PersonIdAddressesAddresspersonid500
      >,
      {
        id: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["id"];
        addressPersonId: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiV1PersonIdAddressesAddresspersonidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1PersonIdAddressesAddresspersonid401
      | DeleteApiV1PersonIdAddressesAddresspersonid404
      | DeleteApiV1PersonIdAddressesAddresspersonid500
    >,
    {
      id: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["id"];
      addressPersonId: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1PersonIdAddressesAddresspersonidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1PersonIdAddressesAddresspersonid401
      | DeleteApiV1PersonIdAddressesAddresspersonid404
      | DeleteApiV1PersonIdAddressesAddresspersonid500
    >,
    {
      id: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["id"];
      addressPersonId: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"];
    },
    TContext
  >;
}
